import { SvgIconType } from './svg.interface';

const Chat: SvgIconType = ({
  width = 12,
  height = 12,
  className = '',
  color = '#3AA5DC'
}) => (
  <svg
    width={width}
    height={height}
    className={className}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M9.23637 8.98072L8.69371 11.8411C8.68645 11.8794 8.66861 11.9145 8.64243 11.9421C8.56921 12.0193 8.45049 12.0193 8.37727 11.9421L6.29248 9.74431C6.19557 9.74809 6.09806 9.75 6 9.75C2.68629 9.75 0 7.56739 0 4.875C0 2.18261 2.68629 0 6 0C9.31371 0 12 2.18261 12 4.875C12 6.59897 10.8986 8.11393 9.23637 8.98072Z"
      fill={color}
    />
  </svg>
);

export default Chat;
